<template>
  <div>
    <action-header
      v-if="!hasValidRole(role, [Role.Student, Role.Family])"
      :button="buttonSearch"
      :data.sync="studentValue"
      @studentValue="studentValue = $event"
      @export-pdf="exportPdf()"
      :show-export="showExport"
      ref="actionHeader"
    ></action-header>
    <div v-else class="md-layout hidden lg:block">
      <div class="md-layout-item text-right">
        <md-button
          class="md-warning"
          @click.prevent="exportPdf()"
          v-if="showExport"
        >
          {{ $t("common.export") }}
        </md-button>
      </div>
    </div>
    <div v-if="searchResult.username">
      <general-assessment :data="searchResult"></general-assessment>
      <detail :data-detail="searchResult"></detail>

      <div v-if="showExport">
        <pdf-default ref="pdfContent" pdf-format="letter">
          <template #pdf-content>
            <export-pdf-ielts :data="searchResult"></export-pdf-ielts>
          </template>
        </pdf-default>
      </div>
    </div>
    <div class="md-layout" v-else>
      <div class="md-layout-item md-empty-page">
        <student-image class="student-image w-full"></student-image>
        <div>
          <h2 class="font-bold text-2xl">
            {{ $t("smi_sri.get_assessment") }}
          </h2>
          <p>
            {{ $t("smi_sri.please_select_the_student") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { service_paths, service_names } from "@/constants/Services";
import ActionHeader from "./Component/ActionHeader";
import Detail from "./Component/Detail";
import GeneralAssessment from "../Components/General";
import StudentImage from "@/components/Base/Illustration/Student";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import { mapGetters, mapState } from "vuex";
import { getId, Message } from "@/helpers/utils";
import ExportPdfIelts from "./Component/ExportPdfIelts";
import PdfDefault from "../../../components/PdfDefault";

export default {
  components: {
    PdfDefault,
    ExportPdfIelts,
    StudentImage,
    GeneralAssessment,
    Detail,
    ActionHeader
  },
  data() {
    return {
      buttonSearch: {
        title: "common.search",
        action: this.searchStudent
      },
      studentValue: null,
      searchResult: {},
      hasValidRole,
      Role,
      showExport: false,
      getId
    };
  },
  watch: {
    studentValue() {
      this.searchResult = {};
      this.showExport = false;
    }
  },
  computed: {
    ...mapState("switchAccountChild", ["currentChild"]),
    ...mapState("user", ["info"]),
    ...mapGetters("user", ["role"])
  },
  mounted() {
    if (hasValidRole(this.role, Role.Student)) {
      this.studentValue = getId(this.info);
      this.searchStudent();
    }

    if (hasValidRole(this.role, Role.Family)) {
      this.studentValue = getId(this.currentChild);
      this.searchStudent();
    }

    const query = this.$route.query;
    if (!hasValidRole(this.role, Role.Student) && query.tabName === "IELTS") {
      this.setInfoStudentByQuery(query);
    }
  },
  methods: {
    setInfoStudentByQuery(query) {
      this.studentValue = query.id;
      this.searchStudent();
      this.$router.replace({ query: {} });
    },
    searchStudent() {
      if (!this.studentValue) {
        Message.error(
          this.$t("smi_sri.please_select_the_student_to_view_report")
        );
        return;
      }
      this.$axios
        .get(
          `${service_names.school}/user/${this.studentValue}/individual/ielts`
        )
        .then(response => {
          this.searchResult = response.data;
          this.showExport = !!this.searchResult.ielts.length;
          if (!hasValidRole(this.role, [Role.Student, Role.Family])) {
            this.$refs.actionHeader.studentData.displayValue =
              this.searchResult?.full_name +
                " - " +
                this.searchResult?.student_code || "";
          }
          this.getChartData();
        });
    },
    getChartData() {
      return this.$axios
        .get(
          `${service_paths.ielts}/chart-individual/user/${this.studentValue}`
        )
        .then(response => {
          this.searchResult = {
            ...this.searchResult,
            ...response.data
          };
        });
    },
    exportPdf() {
      this.$refs.pdfContent.generatePdf();
    }
  }
};
</script>
